import invoice from './invoice/reducer'

export default {
  invoice
}
